import {
  dbUserProfileSchema,
  dbUserProfileUpdateSchema,
} from '../user-profiles/db-user-profile';
import { z } from '@harvestiq/zod';

export const updateUserProfileRequestSchema = dbUserProfileUpdateSchema.extend({
  avatarId: z.string().uuid().nullable().optional(),
});
export type UpdateUserProfileRequest = z.infer<
  typeof updateUserProfileRequestSchema
>;

export const updateUserProfileResponseSchema = z
  .object({
    userProfile: dbUserProfileSchema,
  })
  .or(z.object({ errors: z.array(z.string()) }));
export type UpdateUserProfileResponse = z.infer<
  typeof updateUserProfileResponseSchema
>;
